export default "__VITE_ASSET__DXKLkY3z__"